/**
 * User-facing copy for the retired onboarding checkout
 * `/onboard/place-order/:offerCode` (hubspot-off-block-3 task 98). No copy for
 * this page is written inline in the component.
 */
const strings = {
  redirecting: 'Taking you to our pricing page…',
  fallbackLink: 'Continue to pricing',
};

export default strings;
